export default __webpack_public_path__ + "static/media/not-favorites.f99009f3.ico";